/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { SubjectWalletResult } from '../model/subjectWalletResult';
// @ts-ignore
import { WalletAndDIDParams } from '../model/walletAndDIDParams';
// @ts-ignore
import { X509CertificateAndDIDResult } from '../model/x509CertificateAndDIDResult';
// @ts-ignore
import { X509CertificateParams } from '../model/x509CertificateParams';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    SubjectWalletsServiceInterface
} from './subjectWallets.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class SubjectWalletsService extends BaseService implements SubjectWalletsServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * createX509CertificateAndDID
     * Service to request a DID with his X509 Certificate. &lt;hr&gt;  Requires authorization of any of following types:  * USER_AUTH_BASIC * USER_BEARER_TOKEN * OAUTH_USER_LOGIN_USER_PASSWORD * OAUTH_USER_CLIENT_CREDENTIAL * OAUTH_USER_LOGIN_PRESENTATION  Token subjects allowed:  * AUTHENTICATE_USER * AUTHENTICATE_PASSWORDLESS_USER_SHORT_LIVED
     * @param x509CertificateParams PKCS#10 for create the X509 Certificate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createX509CertificateAndDID(x509CertificateParams: X509CertificateParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<X509CertificateAndDIDResult>;
    public createX509CertificateAndDID(x509CertificateParams: X509CertificateParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<X509CertificateAndDIDResult>>;
    public createX509CertificateAndDID(x509CertificateParams: X509CertificateParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<X509CertificateAndDIDResult>>;
    public createX509CertificateAndDID(x509CertificateParams: X509CertificateParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (x509CertificateParams === null || x509CertificateParams === undefined) {
            throw new Error('Required parameter x509CertificateParams was null or undefined when calling createX509CertificateAndDID.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OAUTH_USER_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_PRESENTATION) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_PRESENTATION', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_USER_PASSWORD) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_USER_PASSWORD', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (USER_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (USER_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_BEARER_TOKEN', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/SubjectWallets/X509Certificate`;
        return this.httpClient.request<X509CertificateAndDIDResult>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: x509CertificateParams,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Request a new DID
     * Service to request a DID with his wallet and all his info. &lt;hr&gt;  Requires authorization of any of following types:  * USER_AUTH_BASIC * USER_BEARER_TOKEN * OAUTH_USER_LOGIN_USER_PASSWORD * OAUTH_USER_CLIENT_CREDENTIAL * OAUTH_USER_LOGIN_PRESENTATION  Token subjects allowed:  * AUTHENTICATE_USER * AUTHENTICATE_PASSWORDLESS_USER_SHORT_LIVED
     * @param walletAndDIDParams password for the new created wallet
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postWalletAndDID(walletAndDIDParams: WalletAndDIDParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubjectWalletResult>;
    public postWalletAndDID(walletAndDIDParams: WalletAndDIDParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubjectWalletResult>>;
    public postWalletAndDID(walletAndDIDParams: WalletAndDIDParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubjectWalletResult>>;
    public postWalletAndDID(walletAndDIDParams: WalletAndDIDParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (walletAndDIDParams === null || walletAndDIDParams === undefined) {
            throw new Error('Required parameter walletAndDIDParams was null or undefined when calling postWalletAndDID.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OAUTH_USER_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_PRESENTATION) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_PRESENTATION', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_USER_PASSWORD) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_USER_PASSWORD', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (USER_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (USER_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_BEARER_TOKEN', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/SubjectWallets`;
        return this.httpClient.request<SubjectWalletResult>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: walletAndDIDParams,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
